import React from 'react';

function ChatIcon({ props }) {
  return (
    <svg
      width="140"
      height="105"
      viewBox="0 0 140 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_591_16566)">
        <path
          d="M130.9 48.65C130.9 70.85 107.9 89.25 78.0001 92.15C52.6001 89.35 33.1001 73.65 33.1001 54.65C33.1001 33.75 56.9001 16.75 86.2001 16.75C100.8 16.75 114.1 20.95 123.7 27.85C128.3 34.05 130.9 41.15 130.9 48.65Z"
          fill="black"
          fillOpacity="0.1"
        />
        <path
          d="M135.9 104.25C135.7 104.25 135.5 104.25 135.3 104.15C126.9 101.55 118.7 97.9498 111.2 93.5498C108.1 91.7498 104.5 91.2498 100.8 91.9498C96 92.9498 91.1 93.4498 86.1 93.4498C56.4 93.4498 32.3 76.0498 32.3 54.7498C32.3 33.4498 56.5 16.0498 86.1 16.0498C115.8 16.0498 140 33.4498 140 54.7498C140 62.7498 136.7 70.4498 130.3 76.9498C128.6 78.7498 128 81.2498 128.7 83.4498C130.1 87.8498 132.8 94.5498 137.5 101.05C138 101.75 138 102.65 137.5 103.45C137.2 103.95 136.6 104.25 135.9 104.25ZM103.9 90.0498C106.8 90.0498 109.5 90.7498 112 92.1498C119.5 96.4498 127.5 99.9498 135.8 102.55C136.1 102.65 136.2 102.45 136.3 102.35C136.4 102.25 136.5 102.05 136.3 101.85C131.5 95.1498 128.7 88.3498 127.3 83.7498C126.4 80.9498 127.1 77.7498 129.2 75.6498C135.2 69.4498 138.4 62.1498 138.4 54.6498C138.4 34.1498 115 17.5498 86.1 17.5498C57.3 17.5498 33.9 34.2498 33.9 54.6498C33.9 75.0498 57.3 91.7498 86.1 91.7498C91 91.7498 95.8 91.2498 100.5 90.3498C101.7 90.1498 102.8 90.0498 103.9 90.0498Z"
          fill="#006838"
        />
        <path
          d="M124.4 45.5498C124.4 69.8498 96.9001 89.5498 62.9001 89.5498C57.1001 89.5498 51.4002 88.9498 46.0001 87.8498C41.7001 86.9498 37.2001 87.6498 33.4001 89.8498C25.9001 94.1498 16.6001 98.5498 5.60015 101.95C4.30015 102.35 3.20015 100.85 4.00015 99.7498C9.50015 92.1498 12.6001 84.2498 14.3001 79.0498C15.3001 76.0498 14.5001 72.7498 12.3001 70.5498C5.40015 63.4498 1.40015 54.8498 1.40015 45.5498C1.40015 21.2498 28.9001 1.5498 62.9001 1.5498C96.8001 1.5498 124.4 21.2498 124.4 45.5498Z"
          fill="white"
        />
        <path
          d="M5.2001 102.85C4.5001 102.85 3.8001 102.55 3.4001 101.95C2.8001 101.15 2.8001 100.15 3.4001 99.35C8.8001 91.75 11.9001 83.95 13.6001 78.85C14.5001 76.15 13.8001 73.25 11.8001 71.15C4.5001 63.55 0.600098 54.75 0.600098 45.55C0.600098 20.85 28.5001 0.75 62.9001 0.75C97.2001 0.75 125.2 20.85 125.2 45.55C125.2 70.25 97.2001 90.25 62.9001 90.25C57.1001 90.25 51.4001 89.65 45.9001 88.55C41.7001 87.65 37.4001 88.35 33.8001 90.45C25.0001 95.55 15.6001 99.65 5.8001 102.75C5.6001 102.75 5.4001 102.85 5.2001 102.85ZM62.9001 2.35C29.4001 2.35 2.2001 21.75 2.2001 45.55C2.2001 54.35 5.9001 62.85 12.9001 70.05C15.3001 72.55 16.2001 76.15 15.1001 79.35C13.4001 84.65 10.2001 92.55 4.7001 100.25C4.5001 100.55 4.6001 100.85 4.7001 100.95C4.8001 101.05 5.0001 101.35 5.4001 101.15C15.1001 98.15 24.3001 94.05 33.0001 89.05C36.9001 86.75 41.6001 86.05 46.2001 86.95C51.6001 88.05 57.2001 88.65 62.9001 88.65C96.4001 88.65 123.6 69.25 123.6 45.45C123.6 21.75 96.3001 2.35 62.9001 2.35Z"
          fill="#006838"
        />
        <path
          d="M35.9 52.8504C40.0974 52.8504 43.5 49.4478 43.5 45.2504C43.5 41.053 40.0974 37.6504 35.9 37.6504C31.7027 37.6504 28.3 41.053 28.3 45.2504C28.3 49.4478 31.7027 52.8504 35.9 52.8504Z"
          fill="#FF8A00"
        />
        <path
          d="M63.2001 52.8504C67.3975 52.8504 70.8001 49.4478 70.8001 45.2504C70.8001 41.053 67.3975 37.6504 63.2001 37.6504C59.0027 37.6504 55.6001 41.053 55.6001 45.2504C55.6001 49.4478 59.0027 52.8504 63.2001 52.8504Z"
          fill="#FF8A00"
        />
        <path
          d="M90.5001 52.8504C94.6975 52.8504 98.1001 49.4478 98.1001 45.2504C98.1001 41.053 94.6975 37.6504 90.5001 37.6504C86.3028 37.6504 82.9001 41.053 82.9001 45.2504C82.9001 49.4478 86.3028 52.8504 90.5001 52.8504Z"
          fill="#FF8A00"
        />
      </g>
      <defs>
        <clipPath id="clip0_591_16566">
          <rect
            width="139.4"
            height="103.5"
            fill="white"
            transform="translate(0.600098 0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ChatIcon;
